import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '@/components/upload/uploadFile';
import { uploadFile as uploadApi } from '@/components/upload/upload';
import formHelpers from './utils/form';
import SectionEditActions from './SectionEditActions';
import ReferenceStyleGalleryDialog from './ReferenceStyleGalleryDialog';
export default {
  name: 'CustomDesignTab',
  components: {
    UploadFile: UploadFile,
    SectionEditActions: SectionEditActions,
    ReferenceStyleGalleryDialog: ReferenceStyleGalleryDialog
  },
  mixins: [formHelpers],
  inject: {
    elForm: {
      default: null
    }
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'add'
    },
    editSaving: {
      type: Boolean,
      default: false
    },
    cardDesignPersonList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cardTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    businessTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showCardTypeField: {
      type: Boolean,
      default: false
    },
    hadInitialDesignDraft: {
      type: Boolean,
      default: false
    },
    isTaskFormDisabled: {
      type: Function,
      required: true
    },
    isEditingTask: {
      type: Function,
      required: true
    },
    isViewTaskDisabled: {
      type: Function,
      required: true
    },
    showProjectInfoEditButton: {
      type: Function,
      required: true
    },
    startProjectInfoEdit: {
      type: Function,
      required: true
    },
    confirmProjectInfoEdit: {
      type: Function,
      required: true
    },
    cancelProjectInfoEdit: {
      type: Function,
      required: true
    },
    changeOrderBusinessType: {
      type: Function,
      required: true
    }
  },
  computed: {
    designDraftList: function designDraftList() {
      var _this$formData$items, _this$formData$items$;
      return ((_this$formData$items = this.formData.items) === null || _this$formData$items === void 0 ? void 0 : (_this$formData$items$ = _this$formData$items.card_and_coupon_design) === null || _this$formData$items$ === void 0 ? void 0 : _this$formData$items$.design_draft) || [];
    },
    // 保留原始下标，缩略图/文件分栏展示后仍能按原数组位置删除
    designDraftImageList: function designDraftImageList() {
      var _this = this;
      return this.designDraftList.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          __index: index
        });
      }).filter(function (item) {
        return _this.isImageFile(item);
      });
    },
    designDraftFileList: function designDraftFileList() {
      var _this2 = this;
      return this.designDraftList.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          __index: index
        });
      }).filter(function (item) {
        return !_this2.isImageFile(item);
      });
    },
    designDraftImageSrcList: function designDraftImageSrcList() {
      var _this3 = this;
      return this.designDraftImageList.map(function (item) {
        return _this3.$ossurl + item.url;
      });
    },
    customerLogoImageSrcList: function customerLogoImageSrcList() {
      var _this$formData$items2,
        _this$formData$items3,
        _this4 = this;
      var files = ((_this$formData$items2 = this.formData.items) === null || _this$formData$items2 === void 0 ? void 0 : (_this$formData$items3 = _this$formData$items2.card_and_coupon_design) === null || _this$formData$items3 === void 0 ? void 0 : _this$formData$items3.customer_logo) || [];
      return files.filter(function (item) {
        return _this4.isImageFile(item);
      }).map(function (item) {
        return _this4.$ossurl + item.url;
      });
    },
    referenceStyleImageSrcList: function referenceStyleImageSrcList() {
      var _this$formData$items4,
        _this$formData$items5,
        _this5 = this;
      return (((_this$formData$items4 = this.formData.items) === null || _this$formData$items4 === void 0 ? void 0 : (_this$formData$items5 = _this$formData$items4.card_and_coupon_design) === null || _this$formData$items5 === void 0 ? void 0 : _this$formData$items5.refer_style) || []).map(function (item) {
        return _this5.getReferenceStyleUrl(item.url);
      });
    }
  },
  methods: {
    getReferenceStyleUrl: function getReferenceStyleUrl(url) {
      return /^(https?:)?\/\//.test(url) ? url : this.$ossurl + url;
    },
    openReferenceStyleGallery: function openReferenceStyleGallery() {
      this.$refs.referenceStyleGallery.open();
    },
    changeDesignProductType: function changeDesignProductType() {
      var _this6 = this;
      this.formData.items.card_and_coupon_design.add_magnetic_stripe = '';
      this.formData.items.card_and_coupon_design.card_size = '';
      this.formData.items.card_and_coupon_design.card_size_custom = '';
      this.formData.items.card_and_coupon_design.coupon_size = '';
      this.formData.items.card_and_coupon_design.coupon_size_custom = '';
      this.formData.items.card_and_coupon_design.gift_coupon_type = '';
      this.formData.items.card_and_coupon_design.gift_coupon_size = '';
      this.formData.items.card_and_coupon_design.gift_coupon_size_custom = '';
      this.formData.items.card_and_coupon_design.gift_coupon_special_requirement = '';
      this.formData.items.card_and_coupon_design.card_coupon_sleeve_size = '';
      this.formData.items.card_and_coupon_design.card_coupon_sleeve_size_custom = '';
      if (['7', '8'].includes(this.formData.items.card_and_coupon_design.design_product_type)) {
        this.formData.items.card_and_coupon_design.need_card_coupon_sleeve = '';
      }
      this.$nextTick(function () {
        _this6.elForm && _this6.elForm.clearValidate(['items.card_and_coupon_design.add_magnetic_stripe', 'items.card_and_coupon_design.card_size', 'items.card_and_coupon_design.card_size_custom', 'items.card_and_coupon_design.coupon_size', 'items.card_and_coupon_design.coupon_size_custom', 'items.card_and_coupon_design.gift_coupon_type', 'items.card_and_coupon_design.gift_coupon_size', 'items.card_and_coupon_design.gift_coupon_size_custom', 'items.card_and_coupon_design.gift_coupon_special_requirement', 'items.card_and_coupon_design.card_coupon_sleeve_size', 'items.card_and_coupon_design.card_coupon_sleeve_size_custom']);
      });
    },
    changeCardSize: function changeCardSize() {
      var _this7 = this;
      if (this.formData.items.card_and_coupon_design.card_size !== '2') {
        this.formData.items.card_and_coupon_design.card_size_custom = '';
      }
      this.$nextTick(function () {
        _this7.elForm && _this7.elForm.clearValidate('items.card_and_coupon_design.card_size_custom');
      });
    },
    changeCouponSize: function changeCouponSize() {
      var _this8 = this;
      if (this.formData.items.card_and_coupon_design.coupon_size !== '2') {
        this.formData.items.card_and_coupon_design.coupon_size_custom = '';
      }
      this.$nextTick(function () {
        _this8.elForm && _this8.elForm.clearValidate('items.card_and_coupon_design.coupon_size_custom');
      });
    },
    changeGiftCouponType: function changeGiftCouponType() {
      var _this9 = this;
      this.formData.items.card_and_coupon_design.gift_coupon_size = '';
      this.formData.items.card_and_coupon_design.gift_coupon_size_custom = '';
      this.formData.items.card_and_coupon_design.gift_coupon_special_requirement = '';
      this.$nextTick(function () {
        _this9.elForm && _this9.elForm.clearValidate(['items.card_and_coupon_design.gift_coupon_size', 'items.card_and_coupon_design.gift_coupon_size_custom', 'items.card_and_coupon_design.gift_coupon_special_requirement']);
      });
    },
    changeGiftCouponSize: function changeGiftCouponSize() {
      var _this0 = this;
      if (this.formData.items.card_and_coupon_design.gift_coupon_size !== '2') {
        this.formData.items.card_and_coupon_design.gift_coupon_size_custom = '';
      }
      this.$nextTick(function () {
        _this0.elForm && _this0.elForm.clearValidate('items.card_and_coupon_design.gift_coupon_size_custom');
      });
    },
    changeNeedSleeve: function changeNeedSleeve() {
      var _this1 = this;
      if (this.formData.items.card_and_coupon_design.need_card_coupon_sleeve !== '1') {
        this.formData.items.card_and_coupon_design.card_coupon_sleeve_size = '';
        this.formData.items.card_and_coupon_design.card_coupon_sleeve_size_custom = '';
      }
      this.$nextTick(function () {
        _this1.elForm && _this1.elForm.clearValidate(['items.card_and_coupon_design.card_coupon_sleeve_size', 'items.card_and_coupon_design.card_coupon_sleeve_size_custom']);
      });
    },
    changeSleeveSize: function changeSleeveSize() {
      var _this10 = this;
      if (this.formData.items.card_and_coupon_design.card_coupon_sleeve_size !== '2') {
        this.formData.items.card_and_coupon_design.card_coupon_sleeve_size_custom = '';
      }
      this.$nextTick(function () {
        _this10.elForm && _this10.elForm.clearValidate('items.card_and_coupon_design.card_coupon_sleeve_size_custom');
      });
    },
    changeNeedPrinting: function changeNeedPrinting() {
      var _this11 = this;
      var designData = this.formData.items.card_and_coupon_design;
      if (designData.need_printing === '1') return;
      designData.printing_quantity = '';
      designData.urgent_printing = '';
      this.$nextTick(function () {
        _this11.elForm && _this11.elForm.clearValidate(['items.card_and_coupon_design.printing_quantity', 'items.card_and_coupon_design.urgent_printing']);
      });
    },
    handlePrintingQuantityInput: function handlePrintingQuantityInput(value) {
      this.formData.items.card_and_coupon_design.printing_quantity = String(value || '').replace(/\D/g, '').replace(/^0+/, '');
    },
    handleCardAndCouponDesignFileUploaded: function handleCardAndCouponDesignFileUploaded(key, url, fileName, uid) {
      var fileItem = {
        file_name: fileName,
        url: key
      };
      this.formData.items.card_and_coupon_design.customer_logo.push(fileItem);
      this.elForm && this.elForm.validateField('items.card_and_coupon_design.customer_logo');
    },
    deleteCardAndCouponDesignFile: function deleteCardAndCouponDesignFile(index) {
      var _this12 = this;
      this.formData.items.card_and_coupon_design.customer_logo.splice(index, 1);
      this.$nextTick(function () {
        _this12.elForm && _this12.elForm.validateField('items.card_and_coupon_design.customer_logo');
      });
    },
    handleReferenceStyleFileUploaded: function handleReferenceStyleFileUploaded(key, url, fileName) {
      var designData = this.formData.items.card_and_coupon_design;
      if (designData.refer_style.length >= 4) {
        this.$message.warning('最多支持上传/选择4张图片');
        return;
      }
      designData.refer_style.push({
        file_name: fileName,
        url: key
      });
      this.elForm && this.elForm.validateField('items.card_and_coupon_design.refer_style');
    },
    deleteReferenceStyle: function deleteReferenceStyle(index) {
      this.formData.items.card_and_coupon_design.refer_style.splice(index, 1);
      this.elForm && this.elForm.validateField('items.card_and_coupon_design.refer_style');
    },
    handleDesignDraftFileUploaded: function handleDesignDraftFileUploaded(key, url, fileName) {
      this.addDesignDraftFile({
        file_name: fileName,
        url: key
      });
    },
    uploadDesignDraftFile: function uploadDesignDraftFile() {
      this.$refs.designDraftUpload.uploadBanner();
    },
    addDesignDraftFile: function addDesignDraftFile(fileItem) {
      var designData = this.formData.items.card_and_coupon_design;
      if (!designData.design_draft) {
        this.$set(designData, 'design_draft', []);
      }
      if (designData.design_draft.length >= 9) {
        this.$message.warning('设计稿最多上传9个');
        return;
      }
      designData.design_draft.push(fileItem);
      this.elForm && this.elForm.validateField('items.card_and_coupon_design.design_draft');
    },
    deleteDesignDraftFile: function deleteDesignDraftFile(index) {
      this.formData.items.card_and_coupon_design.design_draft.splice(index, 1);
      this.elForm && this.elForm.validateField('items.card_and_coupon_design.design_draft');
    },
    handleDesignDraftPaste: function handleDesignDraftPaste(event) {
      var _iterator = _createForOfIteratorHelper(event.clipboardData.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.type.indexOf('image') === -1) continue;
          var file = item.getAsFile();
          if (file) this.uploadDesignDraftFromPaste(file);
          break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    uploadDesignDraftFromPaste: function uploadDesignDraftFromPaste(file) {
      var _this13 = this;
      var loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      uploadApi(file, null, {
        config: '/user/project-delivery-file/upload/config'
      }).then(function (response) {
        if (response.status !== 200) {
          _this13.$message.error('上传失败');
          return;
        }
        _this13.addDesignDraftFile({
          file_name: file.name,
          url: response.config.key
        });
      }).catch(function () {
        _this13.$message.error('上传失败');
      }).finally(function () {
        loading.close();
      });
    }
  }
};